import { BoxGeometry, MeshLambertMaterial, MeshStandardMaterial } from 'three'

export function toLambert(mat: MeshStandardMaterial): MeshLambertMaterial {
  const m = new MeshLambertMaterial()
  m.name = mat.name
  m.map = mat.map
  m.color.copy(mat.color)
  m.alphaTest = mat.alphaTest
  m.transparent = mat.transparent
  m.opacity = mat.opacity
  m.side = mat.side
  m.vertexColors = mat.vertexColors
  m.emissive.copy(mat.emissive)
  m.emissiveIntensity = mat.emissiveIntensity
  return m
}

export const BOX_GEOMETRY = new BoxGeometry()

export const METAL_MATERIAL = new MeshLambertMaterial({
  color: '#b0bec5',
})

export const METAL_MATERIAL_TRANSPARENT = new MeshLambertMaterial({
  color: '#b0bec5',
  transparent: true,
  opacity: 0.1,
})

export const WOOD_MATERIAL = new MeshLambertMaterial({ color: '#BD755B' })

export const WOOD_MATERIAL_LIGHT = new MeshLambertMaterial({ color: '#F1976C' })

export const WOOD_MATERIAL_LIGHT_TRANSPARENT = new MeshLambertMaterial({
  color: '#F1976C',
  transparent: true,
  opacity: 0.1,
})
